<template>
	<div class>
		<ModalBox v-model="legacyModalVisible" placement="right" size="sm" hide-close header-class="!hidden">

			<div class="modal-container w-full">
				<div class="mt-100 px-3 flex flex-wrap items-start">
					<div class="mt-3 w-2/3">
						<router-link :to="{ path: '/dashboard' }" class="modal-logo">
							<!-- <img height="32px" class="logo-icon" src="https://castr.com/wp-content/uploads/2023/12/Christmas_logo_2023.png" alt="Streaming Dashboard - Castr"   /> -->
							<img height="32px" class="logo-icon" src="@/assets/castr.svg" alt="Streaming Dashboard - Castr"  />
							<div class="logo-icon-dot" />
						</router-link>
					</div>
					<div class="mt-3 text-right w-1/3">
						<FormButton type="light" :isIcon="true" class="px-2" @click="closeModal">
							<img src="@/assets/images/menu-close.svg" alt="Menu close">
						</FormButton>
					</div>
				</div>
				<div class="mt-100 px-3 flex flex-wrap">
					<div class="w-full">
						<h3 class="text-s-l text-500">New CDN resource</h3>
						<p class="text-dark-8 mb-4 text-s-s">Create CDN resource.</p>
						<Alert v-if="error" type="error" class="flex items-start px-2">
							<div v-if="error == 'Please contact the sales team to get more origins.'" class="-mt-1">
								<p class="text-s-m text-500 mb-0">You don’t have enough quota</p>
								<p class="text-s-s text-500 mb-0">Please contact <FormButton class="text-reset text-underline text-s-s text-500 mb-0 px-0 py-0" style="    transform: translateY(-1px);" type="link" size="sm" onclick="Intercom('show')">sales</FormButton> team to get more origins</p>
							</div>
							<div class="-mt-1" v-else>
								<p class="text-s-m text-500 mb-0">{{error}}</p>
							</div>
						</Alert>
					</div>
				</div>
				<div class="px-3 flex flex-wrap">
					<div class="w-full">
						<label class="text-dark-8 text-s-s">
							CDN name
						</label>
						<FormInput v-model="originName" class="input" placeholder="CDN name" />
					</div>
				</div>
				<div class="px-3 flex flex-wrap">
					<div class="w-full">
						<div>
							<div class="text-center">
								<FormButton :disabled="originName.length === 0 || processing" @click="onConfirm" type="main" size="md" class="w-full mt-4">
									Create CDN resource
									<Spinner v-if="processing" classes="ml-2 text-dark-8 mh-60" spinner-color="var(--c-dark-8)" spinner-size="15px" />
								</FormButton>
								<div class="mt-2">
									<FormButton type="secondary" size="md" class="w-full mb-3 md:mb-0"
										@click="closeModal">
										Cancel
									</FormButton>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		
</ModalBox>
	</div>
</template>

<script>
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import _ from 'lodash';
import Spinner from "@/components/ui/Spinner.vue"
import OriginService from '@/services/OriginService'
import FormButton from '@/components/Atoms/FormButton.vue';
import Alert from '@/components/Atoms/Alert.vue';
import FormInput from '@/components/Atoms/FormInput.vue';

export default {
	name: 'AddOriginModal',
	mixins: [legacyModalBridgeMixin],
	legacyModalId: 'modal-add-origin',
	components: {
		ModalBox,
		FormButton,
		Spinner,
		FormInput,
	},
	data() {
		return {
			processing: false,
			originName: '',
			error: null,
		};
	},
	props: {
	},
	computed: {
	},
	async mounted() {
	},
	methods: {
		// was @hidden="onReset" on the old b-modal
		onLegacyModalHidden() {
			this.onReset();
		},
		async onConfirm() {
			try {
				// this.$store.dispatch('Ui/setLoadingStatus', true)
				this.processing = true
				const origin = await OriginService.createOrigin(this.originName);
                this.$notify({ group: 'success', text: 'CDN resource created.' })
                this.$emit('origin-created', origin)
                this.closeModal()
				// this.$store.dispatch('Ui/setLoadingStatus', false)
			} catch (err) {
				this.error = err.message
				// this.$store.dispatch('Ui/setLoadingStatus', false)
			}
			this.processing = false
		},
		closeModal() {
			this.originName = ''
			this.hideLegacyModal()
		},
		onReset() {
			this.error = null
		}
	}
};
</script>

<style scoped>
@media (max-width: 767px) {}
</style>
